module.exports = __webpack_public_path__ + "media/EmployerTransitionInformationVideo.6d9aa31f.mp4";